import { render } from "./TopicsListComponent.vue?vue&type=template&id=0c8b331f&scoped=true"
import script from "./TopicsListComponent.vue?vue&type=script&lang=js"
export * from "./TopicsListComponent.vue?vue&type=script&lang=js"

import "./TopicsListComponent.vue?vue&type=style&index=0&id=0c8b331f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8b331f"]])

export default __exports__